import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import PrivateRoutes from "./PrivateRoutes";
import LoadingWidget from "../components/widgets/LoadingWidget";
import ErrorPage from "../components/widgets/ErrorPage";

const Routes = props => {
  const [onLine, setOnLine] = useState(navigator.onLine);
  useEffect(() => {
    window.addEventListener("offline", () => {
      setOnLine(false);
    });
    window.addEventListener("online", () => {
      setOnLine(true);
    });
    return () => {
      window.removeEventListener("offline", () => setOnLine(false));
      window.removeEventListener("online", () => setOnLine(false));
    };
  });

  return (
    <Router>
      <Suspense
        fallback={
          <div style={{ textAlign: "center", padding: "5rem" }}>
            <LoadingWidget color="grey" pageLoader={true} />
          </div>
        }>
        {!onLine ? (
          <Route render={() => <ErrorPage />} />
        ) : !props.isAuthenticated ? (
          <Route path="/*" render={() => <PublicRoutes {...props} />} />
        ) : (
          <Route path="/*" render={() => <PrivateRoutes {...props} />} />
        )}


      </Suspense>
    </Router>
  );
};

export default Routes;
